import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormRow, FileUpload, TagsInput } from '../controls';

const PerformerSchema = Yup.object().shape({
  performerName: Yup.string().required('Performer name is required'),
});

export function PerformerForm({
  performer,
  handleSave,
  performerTypes,
  onFileUpload,
  onFileDelete,
}) {
  const defaultValues = {
    performerDescription: performer.performerDescription || '',
    performerName: performer.performerName || '',
    hometown: performer.hometown || '',
    type: performer.type || undefined,
    subtype: performer.subtype || undefined,
    links: performer.links || {
      instagram: '',
      twitter: '',
      facebook: '',
      web: '',
    },
  };

  const types = performerTypes.types || [];
  const subtypes = performerTypes.subtypes || [];

  const fileList = [];

  if (performer.photoURL) {
    fileList.push({
      uid: '-1',
      name: performer.performerPhoto,
      url: performer.photoURL,
      status: 'done',
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={handleSave}
      validationSchema={PerformerSchema}
    >
      {() => (
        <Form>
          <div className="flex">
            <div className="w-3/4 p-4">
              <FormRow label="Performer Name" errorName="performerName">
                <Field type="text" name="performerName" placeholder="Name" />
              </FormRow>
              <FormRow label="Hometown">
                <Field type="text" name="hometown" placeholder="Hometown" />
              </FormRow>
              <FormRow label="Type" errorName="type">
                <Field
                  name="type"
                  render={({ field, form: { setFieldValue } }) => (
                    <TagsInput
                      value={field.value}
                      placeholder="Select or enter a type"
                      options={types}
                      onChange={(v) => setFieldValue('type', v)}
                    />
                  )}
                />
              </FormRow>
              <FormRow label="Subtype">
                <Field
                  name="subtype"
                  render={({ field, form: { setFieldValue } }) => (
                    <TagsInput
                      value={field.value}
                      placeholder="Select or enter a subtype"
                      options={subtypes}
                      onChange={(v) => setFieldValue('subtype', v)}
                    />
                  )}
                />
              </FormRow>
            </div>
            <div className="w-1/4 p-4">
              <FormRow>
                <div className="w-full">
                  <FileUpload
                    fileList={fileList}
                    onFileUpload={onFileUpload}
                    onFileDelete={onFileDelete}
                  />
                </div>
              </FormRow>
            </div>
          </div>
          <FormRow label="Notes">
            <Field
              component="textarea"
              name="performerDescription"
              placeholder="Performer Biography..."
            />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fas', 'globe']} />}>
            <Field type="text" name="links.web" placeholder="Website" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'facebook']} />}>
            <Field type="text" name="links.facebook" placeholder="Facebook" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'twitter']} />}>
            <Field type="text" name="links.twitter" placeholder="Twitter" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'instagram']} />}>
            <Field type="text" name="links.instagram" placeholder="Instagram" />
          </FormRow>
          <Button className="float-right mt-4" mode="dark">
            Save Performer
          </Button>
        </Form>
      )}
    </Formik>
  );
}
